import { MASTER_GET_ALL } from "../types";

export const fetchAllMasters = () => ({
  type: MASTER_GET_ALL,
  payload: {},
});
